import React, { useState } from 'react';

// ROUTER
import { Link } from 'react-router-dom';

//
import { useSelector } from 'react-redux';

// ANT DESIGN
import { Button, Tooltip } from 'antd';

// UTILITY

import { FormattedMessage } from 'react-intl';

import withTranslations from 'app/components/HOGs/withTranslations';
import { isTourPublic } from 'app/constants/tourAccessibilityTypes.constants';

import { applyingTypes } from 'app/constants/folder.constants';
import { pageScope } from 'app/constants/mapConstants';
import CloseButton from '../../../Utility/closeButton';

import {
  PlaceTypes,
  PlaceIconType,
} from '../../../../constants/place.constant';

import { getTitle, addToDownload } from '../../../Utility/utility';

import { PlacesIcon } from '../../MainMenu/svg';
import { getContainingTourFolders } from '../../Folders/folder.utils';
import FolderMenuButton from '../../Folders/FolderMenu';
import { DeleteIcon, EditIcon } from '../../TourFullView/components/svg';
import SharingPreview from '../../TourPreview/SharingPreview';
import { showDeleteConfirm } from '../../TourFullView/components/deleteConfirm';
import { ShareIcon } from '../../TourstartAcademy/academy.svg';
import ShareTour from '../../Tour/ShareTour';

import PreviewBigImage from '../../TourPreview/PreviewBigImage';
import PreviewBodyWrapper from '../../TourPreview/PreviewBodyWrapper';
import PreviewInfoDownloadView from '../../TourPreview/PreviewInfoDownloadView';

import './placePreview.css';

const previewListStyle = {
  position: 'relative',
  bottom: 0,
  height: 200,
};

const previewViewStyle = {
  marginRight: '350px',
};

const previewListContainerStyle = {
  height: '100%',
};

const previewCreateTourStyle = {
  position: 'absolute',
};

export const previewBody = (props) => {
  const { tr } = props;

  const folders = useSelector((store) => store.foldersPlace);
  // const owner = useSelector((store) => store.placesData.data.user);
  const user = useSelector((store) => store.authentication.user);
  const isLoggedIn = useSelector((store) => store.authentication.isLoggedIn);

  const [sharing, handleShare] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const { previewJson = {} } = props;

  const { category } = previewJson.options;
  const messageText = {
    tourAdded: tr['Already added to download'],
  };

  const title = getTitle(props.previewJson);

  const getCurrentUserId = () => {
    return isLoggedIn && user ? user.id : 0;
  };

  const hasUserPermition = () => {
    const id = getCurrentUserId();
    return id && id === +previewJson.owner?.id;
  };

  const fullData = { data: previewJson };

  const handleEditTour = () => {
    props.closePreviewer({});
    props.removeTourFromMap({
      id: 0,
      points: [],
      poly: '',
    });
    setTimeout(() => props.changeTourMode(true), 2200);
  };

  const deleteTourFromPreviewWindow = (fullData) => {
    console.log(fullData);
    // previewAPI.clearRequests();
    // store.dispatch((dispatch) => {
    //   dispatch({
    //     type: types.DELETE_MAP_ITEM_BY_ID,
    //     payload: fullData.data.id,
    //   });
    //   dispatch({ type: types.FETCH_PREVIEW_DATA_CLEANE });
    //   dispatch({ type: types.FETCH_PREVIEW_POLYLINE_CLEANE });
    //   pageCache.destroy(URL.TOUR.MY[0]);
    // });
    // deleteTourDay(fullData);
  };

  const goTo = ({ urlTitle, previewJson = {} }) => {
    const { id, share_key } = previewJson;
    const key = share_key ? `?share_key=${share_key}` : '';

    return `/place/${urlTitle}_${id}${key}`;
  };

  function activateShare() {
    setTooltipVisible(false);
    handleShare(true);
  }

  const renderProps = () => {
    const accessType = !isTourPublic(props.previewJson.access)
      ? 'Private'
      : 'Public';
    const accessTitle = tr[accessType];
    const placeId = props.previewJson.id;
    const selectedFolders = getContainingTourFolders(folders, +placeId);

    return (
      <>
        {hasUserPermition() ? (
          <div className="middle-buttons-wrapper">
            <FolderMenuButton
              tourId={placeId}
              folders={folders}
              selectedFolders={selectedFolders}
              applying={applyingTypes.PLACE_FOLDER}
            />

            <Link
              to={goTo(props)}
              className="preview-tour-buttons changeFolder"
              style={{ padding: 0 }}
            >
              <Tooltip title={tr.Edit}>
                <Button
                  size="large"
                  className="preview-tour-buttons changeFolder"
                  onClick={handleEditTour}
                  style={{ padding: 0, position: 'relative', bottom: 2 }}
                >
                  <EditIcon />
                </Button>
              </Tooltip>
            </Link>
            <Tooltip title={tr.Delete}>
              <Button
                size="large"
                className="preview-tour-buttons changeFolder"
                style={{ position: 'relative', bottom: 2 }}
                onClick={() => {
                  showDeleteConfirm(
                    deleteTourFromPreviewWindow,
                    tr['Delete the place?'],
                    tr
                  );
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>

            <Tooltip title={accessTitle}>
              <SharingPreview fullData={fullData} type={pageScope.place} />
            </Tooltip>
          </div>
        ) : (
          <div className="middle-buttons-wrapper">
            <FolderMenuButton
              tourId={placeId}
              folders={folders}
              selectedFolders={selectedFolders}
              applying={applyingTypes.PLACE_FOLDER}
            />
            <Tooltip title={accessTitle}>
              <SharingPreview fullData={fullData} type={pageScope.place} />
            </Tooltip>
          </div>
        )}
      </>
    );
  };

  const topButtons = (
    <>
      <div>
        <Tooltip title={tr['Share place']} visible={tooltipVisible}>
          <ShareIcon
            width="18px"
            height="18px"
            className="share_icon"
            onClick={() => activateShare()}
            onMouseEnter={() => setTooltipVisible(true)}
            onMouseLeave={() => setTooltipVisible(false)}
          />
        </Tooltip>
      </div>
      <div>
        <PlacesIcon height="18px" width="18px" />
      </div>
      {sharing ? (
        <ShareTour
          tourUrl={`${props.urlTitle}_${previewJson.id}`}
          type="place"
          shown={sharing}
          cancel={() => handleShare(false)}
        />
      ) : null}
    </>
  );

  return (
    <div className="tourPreviewBody">
      <PreviewBigImage {...props} scope="place" />
      <div className="tourPreviewBodyMainWrapper">
        <div className="entityPreviewBodyContentTitleWrapper">
          <div className="entityPreviewBodyContentTitle">
            <span>{title}</span>
          </div>
          {topButtons}
        </div>
        <div
          style={{
            fontSize: 14,
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            color: 'rgba(0, 0, 0, 0.8)',
          }}
        >
          <img
            style={{
              width: category === '1' ? 14 : 18,
              height: 18,
              marginRight: category === '1' ? 5 : 3,
              marginLeft: category === '1' ? 2 : 0,
            }}
            src={PlaceIconType[category]}
            alt=""
          />
          <span style={{ marginLeft: 3, fontSize: 14 }}>
            {PlaceTypes[category]}
          </span>
        </div>
        <PreviewBodyWrapper
          {...props}
          EntityIcon={PlacesIcon}
          render={renderProps}
        />
        <div className="entity-bottom-buttons-wrapper">
          <PreviewInfoDownloadView {...props} isViewsAvailable />
          <Link to={`/place/create?copy=${props.previewJson.id}`}>
            <Button className="viewBtn entity-bottom-button">
              <span>
                <FormattedMessage
                  id="Plan in Create Tour"
                  defaultMessage="Plan in Create Tour"
                />
              </span>
            </Button>
          </Link>
          <Button
            className="addBtn entity-bottom-button"
            onClick={(e) => {
              addToDownload(
                e,
                props.downloadTourGps.data,
                props.previewJson,
                props.openModalTourDownload,
                props.TourDownloadBasketData,
                props.TourDownloadCoord,
                messageText,
                'place'
              );
            }}
          >
            <span style={{ color: '#333333' }}>
              <FormattedMessage
                id="Add to download"
                defaultMessage="Add to download"
              />
            </span>
          </Button>
          <Link to={`/createtour?place=${props.previewJson.id}`}>
            <Button className="viewBtn createtour entity-bottom-button">
              <span>
                <FormattedMessage
                  id="Create tour"
                  defaultMessage="Create tour"
                />
              </span>
            </Button>
          </Link>
          <Link to={goTo(props)}>
            <Button
              type="primary"
              className="viewBtn entity-bottom-button"
              onClick={() => {
                props.closePreviewer({});
                props.removeTourFromMap({ id: 0, points: [], poly: '' });
              }}
            >
              <span>
                <FormattedMessage id="View" defaultMessage="View" />
              </span>
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

const PlacePreview = (props) => {
  const info =
    props.fetched === false && props.fetching === false ? (
      <div className="tourPreviewBody">
        <FormattedMessage
          id="PLACE IS NOT AVAILABLE"
          defaultMessage="PLACE IS NOT AVAILABLE"
        />
      </div>
    ) : (
      previewBody(props)
    );

  const header = (
    <div
      className="header_close_btn"
      onClick={() => {
        props.closePreviewer({});
        props.removeTourFromMap({ id: 0, points: [], poly: '' });
      }}
      aria-hidden
    >
      <CloseButton />
    </div>
  );

  const getStyle = () => {
    if (props.previewJson.view) {
      return previewViewStyle;
    }
    if (props.fromList) {
      return previewListContainerStyle;
    }

    if (props.createTour) {
      return previewCreateTourStyle;
    }

    return {};
  };

  const render =
    Object.keys(props.previewJson).length === 0 ? null : (
      <div
        id="clubPreviewContainer"
        className="clubPreviewContainer place"
        style={getStyle()}
      >
        <div
          className="tourPreview"
          style={props.fromList ? previewListStyle : {}}
        >
          {props.fromList ? null : header}
          {info}
        </div>
      </div>
    );

  return render;
};

export default withTranslations(PlacePreview);
